import React from 'react';

import BrandButton from 'UI/common/brandButton';
import SafeCheckout from '../safeCheckout';
import StatisticBlock from '../statisticBlock';
import { MoneyBack } from '../moneyBack';
import { appStore } from 'store';
import s from './index.module.scss';
import { Agreements } from 'UI/common/agreements';
import { useT } from '@hooks';


function GetMyPlanBlock(props) {
	const { paymentStore } = appStore;
	const { T } = useT();
	const { withShowCheckout = true, withRenewalText = true, animateButton = false } = props;
	const { currencyType, moneyBack } = appStore.paymentStore.settings;

	function showPaymentModal() {
		// navigate(ROUTES.PAYMENT);
		paymentStore.setPaymentModalVisible(true);
	}

	return (
		<div className={s.getMyPlanBlock}>
			<BrandButton
				data-test='open-payment-modal'
				onClick={showPaymentModal}
				animateButton={animateButton}
			>
				{T('get_my_plan')}
			</BrandButton>
			<div className={s.agreementsWrapper}>
				<Agreements currency={currencyType} withRenewalText={withRenewalText} />
			</div>
			{withShowCheckout && (
				<div className={s.getMyPlanBlock_SafeCheckoutWrapper}>
					<SafeCheckout />
					{moneyBack && <MoneyBack />}
					<StatisticBlock />
				</div>
			)}
		</div>
	);
}

export default GetMyPlanBlock;
